import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";
import * as numberUtils from "util/number";
import InfoTag from "pages/echeck/components/InfoTag";
import { Field } from "formik";
import Checkbox from "pages/_components/Checkbox";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import * as i18n from "util/i18n";

const DraftTransactionItem = ({ transaction, isDesktop, viewTicket, onChange }) => {
    const statusTagColor = (state) => {
        switch (state) {
            case "IN_PROGRESS":
                return "success";
            case "PROCESSING":
                return "reviewed";
            case "DRAFT":
                return "reviewed ";
            default:
                return "error";
        }
    };

    const getOptionsByStatus = (status) => {
        switch (status) {
            case "IN_PROGRESS":
                return [
                    {
                        text: "comex.transfer.option.deleteRequest",
                        textType: "I18N",
                        func: () => undefined,
                    },
                ];

            case "PROCESSING":
                return [
                    {
                        text: "comex.transfer.option.viewObservations",
                        textType: "I18N",
                        func: () => undefined,
                    },
                    {
                        text: "comex.transfer.option.deleteRequest",
                        textType: "I18N",
                        func: () => undefined,
                    },
                ];

            default:
                return null;
        }
    };

    return (
        <>
            {isDesktop ? (
                <GridTable.Data columnStart={1} columnWidth={1} rowStart={0} alignX="center">
                    <Field
                        component={Checkbox}
                        name={transaction.idComexRequest}
                        checked={transaction.idComexRequest}
                        onChange={onChange}
                        hideLabel
                        labelClassName="checkbox-add-contact"
                        n
                    />
                </GridTable.Data>
            ) : (
                <Field
                    component={Checkbox}
                    name={transaction.idComexRequest}
                    checked={transaction.idComexRequest}
                    onChange={onChange}
                    hideLabel
                    labelClassName="checkbox-add-contact"
                    n
                />
            )}
            <GridTable.Data
                columnStart={isDesktop ? 2 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 2}
                alignX="center">
                {isDesktop ? (
                    <CustomText text={transaction.beneficiary} />
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.beneficiary"
                        titleTextType="I18N"
                        valueText={transaction?.beneficiary}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 3 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 3}
                alignX="center">
                {isDesktop ? (
                    <>
                        <CustomText text={transaction?.currency} />
                        &nbsp;
                        <CustomText text={numberUtils.formatAmountStrDouble(transaction?.totalAmount)} />
                    </>
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.amount"
                        titleTextType="I18N"
                        valueText={
                            <CustomText
                                text={`${transaction?.currency} ${numberUtils.formatAmountStrDouble(
                                    transaction?.totalAmount,
                                )}`}
                            />
                        }
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 4 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 4}
                alignX="center">
                {isDesktop ? (
                    <FormattedDate date={transaction?.creationDate} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.creationDate"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={transaction?.creationDate} dateFormat="DD/MM/YYYY" />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 5 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 5}
                alignX="center">
                {isDesktop ? (
                    <InfoTag
                        type="info"
                        message={i18n.get(`comex.transfer.status.${transaction?.status}`)}
                        tagBackground={statusTagColor(transaction?.status)}
                    />
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.status"
                        titleTextType="I18N"
                        valueText={
                            <InfoTag
                                type="info"
                                message={i18n.get(`comex.transfer.status.${transaction?.status}`)}
                                tagBackground={statusTagColor(transaction?.status)}
                            />
                        }
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 6 : 5}
                columnWidth={1}
                rowStart={1}
                alignY="center"
                className="adhered-services-button"
                alignX="center">
                <CustomButton
                    pullRight
                    icon="images/figma/icon/menu-mobile.svg"
                    options={getOptionsByStatus(transaction?.status)}
                />
            </GridTable.Data>
        </>
    );
};

DraftTransactionItem.propTypes = {
    receivedAdheredService: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
    payScheduledService: func.isRequired,
};

export default DraftTransactionItem;
